import React from 'react'
import clsx from 'clsx'
import styles from './UIGameTradeCreatorActionButtons.module.scss'
import {type TradeCreationData, type TradeCreationDataValidator} from '@colonist/game-mechanic-validators'
import {UIGameTradeCreatorActionButtonTradeWithBank} from './UIGameTradeCreatorActionButtonTradeWithBank.tsx'
import {UIGameTradeCreatorActionButtonTradeWithOpponents} from './UIGameTradeCreatorActionButtonTradeWithOpponents.tsx'
import {UIGameActionButtonTrade} from '../../UIGameActionButtonsContainer/UIGameActionButtonTrade/index.ts'

export interface UIGameTradeCreatorActionButtonsProps {
    className?: string | undefined
    isPortraitLayout?: boolean | undefined
    tradeCreationDataValidator: TradeCreationDataValidator
    getCurrentTradeCreationData: (isBankTrade: boolean) => TradeCreationData
}

export const UIGameTradeCreatorActionButtons = ({
    className,
    isPortraitLayout = false,
    tradeCreationDataValidator,
    getCurrentTradeCreationData,
}: UIGameTradeCreatorActionButtonsProps) => (
    <div className={clsx(styles.tradeCreatorActionsContainer, className, {
        [styles.portraitLayout]: isPortraitLayout,
    })}>
        <UIGameTradeCreatorActionButtonTradeWithBank
            hideTooltip={isPortraitLayout}
            tradeCreationDataValidator={tradeCreationDataValidator}
            getCurrentTradeCreationData={getCurrentTradeCreationData} />
        <UIGameTradeCreatorActionButtonTradeWithOpponents
            hideTooltip={isPortraitLayout}
            tradeCreationDataValidator={tradeCreationDataValidator}
            getCurrentTradeCreationData={getCurrentTradeCreationData} />
        {isPortraitLayout && <UIGameActionButtonTrade className={styles.actionButton} />}
    </div>
)
